module.exports = "/_next/static/images/jettyLogo-9a2696543bbb4e87aa519b121d7d8af0.svg";